var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdsProductCheckboxActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 14,
    height: 14,
    rx: 4.5,
    stroke: "#FB4764"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8593 4.08708C12.0226 4.22252 12.0474 4.46744 11.9147 4.63413L6.96232 10.8563C6.88956 10.9478 6.78013 11.0006 6.66474 11C6.54935 10.9994 6.44046 10.9454 6.36859 10.8533L4.08289 7.92146C3.95188 7.7534 3.97912 7.50875 4.14374 7.375C4.30835 7.24126 4.54803 7.26906 4.67904 7.43712L6.66974 9.99054L11.3234 4.14367C11.456 3.97698 11.696 3.95164 11.8593 4.08708Z",
    fill: "#FB4764"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdsProductCheckboxActive);
export default __webpack_public_path__ + "static/media/ADSProductCheckboxActive.32c5cccccb35cc17b890476c5bcebb8a.svg";
export { ForwardRef as ReactComponent };